import React, { FC, useState } from "react";
import { Button, Input, InputGroup } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

interface PasswordInputProps {
  id: string;
  value: string;
  autoComplete?: string;
  // Red border; the caller renders the message.
  invalid?: boolean;
  onChange: (value: string) => void;
}

// Password field with a show/hide toggle, shared by the settings modals.
const PasswordInput: FC<PasswordInputProps> = ({
  id,
  value,
  autoComplete,
  invalid,
  onChange,
}) => {
  const [show, setShow] = useState(false);
  return (
    <InputGroup>
      <Input
        id={id}
        type={show ? "text" : "password"}
        autoComplete={autoComplete}
        invalid={invalid}
        aria-invalid={invalid || undefined}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <Button
        type="button"
        color="light"
        outline
        onClick={() => setShow((s) => !s)}
        title={show ? "Hide password" : "Show password"}
      >
        <FontAwesomeIcon icon={show ? faEyeSlash : faEye} />
      </Button>
    </InputGroup>
  );
};

export default PasswordInput;
